import { render, staticRenderFns } from "./Homicides.vue?vue&type=template&id=6c6e7b6e"
import script from "./Homicides.vue?vue&type=script&lang=js"
export * from "./Homicides.vue?vue&type=script&lang=js"
import style0 from "./Homicides.vue?vue&type=style&index=0&id=6c6e7b6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports